const OPT_OUT_STORAGE_KEY = 'ap-remember-me-opt-out'

export const hasOptedOutRememberMe = (): boolean => {
  try {
    if (typeof window === 'undefined') {
      return false
    }
    return window.localStorage.getItem(OPT_OUT_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const setOptedOutRememberMe = (): void => {
  try {
    if (typeof window === 'undefined') {
      return
    }
    window.localStorage.setItem(OPT_OUT_STORAGE_KEY, 'true')
  } catch {
    // Best-effort: storage unavailable (private mode / disabled). The mint-skip simply won't
    // persist on this device; the consumer can opt out again on the next issuance toast.
  }
}
